module.exports = __webpack_public_path__ + "img/narigin.d867c54f.png";